<template>
    <div class="school-admin">
      <div class="school-admin-header">
        <el-button type="primary" @click="addSchoolAdmin">创建学校管理员</el-button>
      </div>
      <el-table class="customTable" :data="schoolAdminList" style="width: 100%; margin-top: 20px; flex: 1;" height="1%" size="medium"
                :header-cell-style="{fontWeight: 'normal', height: '60px', color: '#666666', background: '#F6F6F6',fontSize: '16px'}"
                :cell-style="{fontSize: '16px',color: '#333333',height: '70px'}">
        <el-table-column prop="nickname" align="center" label="学校管理员名称"></el-table-column>
        <el-table-column prop="username" align="center" label="账号"></el-table-column>
        <el-table-column prop="name" align="center" label="学校"></el-table-column>
        <el-table-column prop="" align="center" label="头像">
          <template slot-scope="scope">
            <div class="column-logo-box">
              <div class="column-logo">
                <img v-if="scope.row.avatar" :src="scope.row.avatar" alt="">
                <img v-else src="./../../../assets/images/user_img.png" alt="">
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-link type="success" :underline="false" @click="editSchoolAdmin(scope.row)">编辑</el-link>
            <el-link type="danger" :underline="false" @click="deleteSchoolAdmin(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="dialogTitle"
          custom-class="green-dialog"
          :visible.sync="schoolDialogVisible"
          @close="resetForm"
          @opened="openAddSchool"
          width="500px">
        <el-form ref="addSchoolAdminForm" :model="addSchoolAdminForm" :rules="addSchoolAdminRules" label-position="top">
          <el-form-item label="管理员名称" prop="nickname">
            <el-input v-model="addSchoolAdminForm.nickname" ref="cursorInput" placeholder="2-26"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="username">
            <el-input v-model="addSchoolAdminForm.username" :disabled="addSchoolAdminForm.id ? true : false" autocomplete="off" placeholder="4-20"></el-input>
          </el-form-item>
          <el-form-item label="重置密码" prop="setPassword" v-if="addSchoolAdminForm.id">
            <el-input v-model="addSchoolAdminForm.setPassword" auto-complete="new-password" minlength="6" maxlength="20" show-password placeholder="6-20"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" v-else>
            <el-input v-model="addSchoolAdminForm.password" auto-complete="new-password" minlength="6" maxlength="20" show-password placeholder="6-20"></el-input>
          </el-form-item>
          <el-form-item label="所属学校" prop="school_id">
            <el-select v-model="addSchoolAdminForm.school_id" placeholder="选择学校">
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="头像">
            <div class="logo-src-box" v-if="addSchoolAdminForm.avatar">
              <div class="src-box">
                <img :src="headerSrc" alt="">
              </div>
              <i @click="clearLogo" class="iconfont">&#xe651;</i>
            </div>
            <el-upload class="logo-uploader"
                       v-else
                       action="admin/upload"
                       :headers="headersParams"
                       name="avatar"
                       :show-file-list="false"
                       :on-success="handleCoverSuccess"
                       :before-upload="beforeCoverUpload">
              <i class="el-icon-plus logo-uploader-icon"></i>
            </el-upload>
            <span class="school-prompt">建议尺寸：200*200；格式为.jpg或.jpeg或.png；大小不超过2M的图片</span>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <el-button  @click="schoolDialogVisible = false">取 消</el-button>
          <el-button style="margin-left: 30px" type="primary" @click="confirmForm('addSchoolAdminForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-pagination class="pager-center" style="margin: 20px 0 30px;text-align: center"
                     :current-page="schoolAdminPages.currentPageNum"
                     :page-size="schoolAdminPages.eachPageNum"
                     :total="schoolAdminPages.total"
                     layout="prev, pager, next, jumper"
                     @current-change="schoolAdminCurrentChange">
      </el-pagination>
    </div>
</template>

<script>
import {adminSchoolAdmins, adminSchoolSchools, adminSchoolAdminAdd, adminSchoolAdminInfo, adminSchoolAdminDel} from '@/utils/apis'
export default {
  name: "SchoolAdministrator",
  data(){
    var validateSetPass = (rule, value, callback) => {
      if(value === ''){
        callback();
      } else {
        if(value.length < 6 || value.length > 20){
          callback(new Error('长度在 6 到 20 个字'))
        } else {
          callback();
        }
      }
    }
    return {
      schoolAdminList:[],
      schoolAdminPages:{
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0,
      },
      dialogTitle:'',
      schoolDialogVisible:false,
      addSchoolAdminForm:{
        id:'',
        nickname:'',
        username:'',
        password:'',
        setPassword:'',
        school_id:'',
        avatar:''
      },
      addSchoolAdminRules:{
        nickname:[
          { required: true, message: '请输入管理员名称', trigger: 'blur' },
          { min: 2, max: 26, message: '长度在 2 到 26 个字', trigger: 'blur' }
        ],
        username:[
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 4, max: 20, message: '长度在 4 到 20 个字', trigger: 'blur' }
        ],
        password:[
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字', trigger: 'blur' }
        ],
        setPassword:[
          { validator: validateSetPass, trigger: 'blur' }
        ],
        school_id:[
          { required: true, message: '请选择所属学校', trigger: 'change' }
        ]
      },
      schoolList:[],
      headersParams:{
        Authorization: localStorage.getItem('adminToken') || ''
      },
      headerSrc:null,
      hostUrl:localStorage.getItem('hosturl') || '',
    }
  },
  mounted() {
    this.getSchoolAdminList();
    this.getSchoolList();
  },
  methods:{
    getSchoolAdminList(){
      let params = {
        page:this.schoolAdminPages.currentPageNum,
        limit:this.schoolAdminPages.eachPageNum
      }
      adminSchoolAdmins(params).then((res)=>{
        this.schoolAdminList = res.data.list;
        this.schoolAdminPages.total = res.data.total;
      }).catch((err)=>{
        console.log('err', err)
      })
    },
    getSchoolList(){
      let params = {
        limit:'all'
      }
      adminSchoolSchools(params).then((res)=>{
        this.schoolList = res.data;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    resetForm(){
      this.$refs.addSchoolAdminForm.resetFields();
      this.headerSrc = null;
      this.addSchoolAdminForm.avatar = '';
      this.addSchoolAdminForm.id = '';
    },
    addSchoolAdmin(){
      this.dialogTitle = '创建学校管理员';
      this.schoolDialogVisible = true;
    },
    openAddSchool(){
      if(this.addSchoolAdminForm.id){
        adminSchoolAdminInfo(this.addSchoolAdminForm.id).then((res)=>{
          this.addSchoolAdminForm.nickname = res.data.nickname;
          this.addSchoolAdminForm.username = res.data.username;
          this.addSchoolAdminForm.school_id = res.data.school_id;
          this.addSchoolAdminForm.avatar = res.data.avatar;
          this.headerSrc = this.hostUrl + res.data.avatar;
        }).catch((err)=>{
          console.log('err', err)
        })
      }
      this.$refs.cursorInput.focus();
    },
    // start 上传图片
    beforeCoverUpload(file) {
      const isImg = file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.png');
      if (!isImg) {
        this.$message.error('上传图片只能是 jpg 或 jpeg 或 png 格式!');
        return false;
      }
      return isImg;
    },
    // 上传图片
    handleCoverSuccess(res, file){
      if (res.code === 200) {
        this.headerSrc = this.hostUrl + res.data.src; // 有域名
        this.addSchoolAdminForm.avatar = res.data.src; //无域名
        this.$message.success('头像上传成功')
      } else {
        this.$message.error('头像上传失败，请稍后再试~')
      }
    },
    clearLogo(){
      this.headerSrc = null;
      this.addSchoolAdminForm.avatar = '';
    },
    confirmForm(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          let formData = new FormData();
          formData.append('username', this.addSchoolAdminForm.username);
          formData.append('nickname', this.addSchoolAdminForm.nickname);
          formData.append('school_id', this.addSchoolAdminForm.school_id);
          formData.append('avatar', this.addSchoolAdminForm.avatar);
          if(this.addSchoolAdminForm.id){
            formData.append('id', this.addSchoolAdminForm.id)
            if(this.addSchoolAdminForm.setPassword){
              formData.append('password', this.addSchoolAdminForm.setPassword)
            }
          } else {
            formData.append('password', this.addSchoolAdminForm.password)
          }
          adminSchoolAdminAdd(formData).then((res)=>{
            this.$message({
              message:res.msg,
              type:'success',
              duration:1000,
              onClose:()=>{
                this.schoolDialogVisible = false;
                this.getSchoolAdminList()
              }
            })
          }).catch((err)=>{
            console.log('err', err)
          })
        } else {
          return false;
        }
      })
    },
    editSchoolAdmin(row){
      this.addSchoolAdminForm.id = row.id;
      this.dialogTitle = '编辑学校管理员';
      this.schoolDialogVisible = true;
    },
    deleteSchoolAdmin(row){
      this.$confirm(`是否删除该学校管理员，删除将无法恢复`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass:'green-message-box',
        type:'warning'
      }).then(()=>{
        adminSchoolAdminDel(row.id).then((res)=>{
          this.$message({
            message:res.msg,
            type:'success',
            duration:1000,
            onClose:()=>{
              this.getSchoolAdminList()
            }
          })
        }).catch((err)=>{
          console.log('err', err)
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    schoolAdminCurrentChange(val){
      this.schoolAdminPages.currentPageNum = val;
      this.getSchoolAdminList();
    }
  }
}
</script>

<style scoped lang="scss">
.school-admin{
  padding: 0px 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  .school-admin-header{
    display: flex;
    justify-content: flex-end;
  }
}
.column-logo-box{
  display: flex;
  align-items: center;
  justify-content: center;
  .column-logo{
    width: 48px;
    height: 48px;
    border: 1px solid #EEEEEE;
    border-radius: 50%;
    overflow: hidden;
    img{
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.logo-uploader{
  ::v-deep .el-upload{
    width: 80px;
    height: 80px;
    background: #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    .logo-uploader-icon{
      font-size: 32px;
      color: #A0A0A0;
    }
  }
}
.school-prompt{
  color: #999;
  font-size: 12px;
}
.logo-src-box{
  width: 80px;
  height: 80px;
  box-sizing: border-box;
  position: relative;
  .src-box{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #EEEEEE;
    img{
      max-width: 100%;
      max-height: 100%;
    }
  }
  i{
    line-height: 1;
    font-size: 14px;
    color: #DCDCDC;
    position: absolute;
    right: -20px;
    top: 0;
    cursor: pointer;
  }
}
</style>